<template>
  <div>
    <Hero :content="moduleData.hero" />
    <ArticleSlice :slice="articleDatas" />
    <Questions v-if="hasQuestions" :content="moduleData.faq" />
    <ArticleDisclaimer :slices="moduleData.articleDisclaimer.body" />
    <OtherArticles v-if="hasArticles" :articles="moduleData.articles" />
  </div>
</template>

<script>
import { ArticleSlice } from '~/components/slices'

import { Hero, Questions, OtherArticles, ArticleDisclaimer } from './components'

export default {
  name: 'AdvicesArticleModule',

  components: {
    Hero,
    ArticleSlice,
    Questions,
    ArticleDisclaimer,
    OtherArticles,
  },

  props: {
    moduleData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasQuestions() {
      return this.moduleData?.faq?.list?.length > 0
    },
    hasArticles() {
      return this.moduleData?.articles?.length > 0
    },

    articleDatas() {
      // Format legacy used slices to make then match with the new articleSlice
      return {
        items: this.moduleData.articleSlices,
        primary: {
          authorInfos: this.moduleData.authorInfos,
          lastPublication: this.moduleData.lastPublication,
        },
      }
    },
  },
}
</script>
